import { ChooseBase } from 'components';
import ContentItem from './ContentItem';
import * as S from './ChooseBrandsModels.styled';

const ChooseContent = ({
  brandsWithSelection,
  isOpened,
  toggle,
  toggleOpened,
  setSearch,
  search,
}) => {
  return (
    <S.Content>
      <ChooseBase.Divided
        title='Search Brands & Models'
        searchValue={search}
        searchOnChange={(e) => setSearch(e.target.value)}
        handleClearSearchValue={() => setSearch('')}
      >
        {brandsWithSelection.map((brandData) => (
          <ContentItem
            search={search}
            isOpened={isOpened(brandData.brand)}
            {...{ brandData }}
            toggleCheck={toggle}
            key={brandData.brand}
            onOpenClick={() => {
              toggleOpened(brandData.brand);
            }}
          />
        ))}
      </ChooseBase.Divided>
    </S.Content>
  );
};

export default ChooseContent;
